import { useTheme } from '@mui/material';

import { ActionIconProps } from '../../../types';
import { ATSConnectHiringRequestTestIds } from 'data-testids/ATS';
import { CTAIconBox, ExpandIconContainer, IconWrapper } from '../../../styles/actionsStyles';
import { getConnectCandidateRowActionText } from '../../../utils';
import { TooltipIconButton } from 'sharedComponents/Buttons/TooltipIconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ConnectHiringRequestAction } from '../../../enums';

export const ExpandIcon = () => {
  const theme = useTheme();

  return (
    <ExpandIconContainer sx={{ marginTop: theme.spacing(-1.75) }}>
      <IconWrapper>
        <ExpandMoreIcon
          data-testid={ATSConnectHiringRequestTestIds.ACTIONS_EXPAND_MORE_ICON}
          sx={{
            height: theme.spacing(2.625),
            width: theme.spacing(2.625),
          }}
        />
      </IconWrapper>
    </ExpandIconContainer>
  );
};

export const ActionIcon: React.FC<ActionIconProps> = ({
  icon,
  isExpanded,
  isMissing,
  isRequired,
  onClick,
  tooltipText,
}) => {
  const theme = useTheme();

  const getIconColor = () => {
    if (!isMissing) {
      return theme.palette.primary.medium;
    }
    if (isRequired) {
      return theme.palette.error.main;
    }
    return theme.palette.text.tertiary;
  };

  const getIconBorder = () => {
    if (isExpanded || !isMissing) {
      return null;
    }
    if (isRequired) {
      return `1px solid ${theme.palette.error.lightest}`;
    }
    return `1px solid ${theme.palette.text.tertiary}`;
  };

  const getIconBackgroundColor = () => {
    if (isExpanded) {
      return null;
    }
    if (!isMissing) {
      return theme.palette.primary.fill;
    }
    if (isRequired) {
      return theme.palette.error.fill;
    }

    return theme.palette.gray.lightest;
  };

  return (
    <TooltipIconButton
      tooltipTitle={getConnectCandidateRowActionText(tooltipText, isMissing, isRequired)}
      dataTestId={`${ATSConnectHiringRequestTestIds.ACTION_ICON_BUTTON}-${tooltipText}`}
      sx={{ padding: 0, '&:hover': { backgroundColor: 'transparent' } }}
      onClick={onClick}
    >
      <CTAIconBox
        data-testid={`${ATSConnectHiringRequestTestIds.ACTION_ICON_BUTTON}-${tooltipText}-icon`}
        sx={{
          color: getIconColor(),
          border: getIconBorder(),
          backgroundColor: getIconBackgroundColor(),
          marginRight: isExpanded ? 'inherit' : theme.spacing(1),
          cursor:
            isMissing && tooltipText === ConnectHiringRequestAction.application
              ? 'default'
              : 'pointer',
        }}
      >
        {icon}
      </CTAIconBox>
    </TooltipIconButton>
  );
};
